import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./Assets/index.css";
import { GlobalStyles } from "./utils";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
    <GlobalStyles />
  </React.StrictMode>
);
